import styled from '@emotion/styled';
import { css } from 'emotion';

import { getThemeColor } from '@ezugi/ui/theme';

const SIZE = 30;

export const Container = styled.div`
  box-sizing: border-box;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  height: 100%;
  overflow: hidden;
  background: ${getThemeColor('primary')};
  color: ${getThemeColor('foreground')};
`;

const button = css`
  cursor: pointer;
  width: ${SIZE}px;
  height: ${SIZE}px;
  flex: none;
  flex-shrink: 0;
  background: ${getThemeColor('primary')};
  color: ${getThemeColor('foreground')};
  outline: none;
  border: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  :disabled {
    > * {
      opacity: 0.5;
    }
  }
`;

export const Prev = styled.button`
  ${button};
`;

export const Next = styled.button`
  ${button};
`;

export const List = styled.ul`
  list-style: none;
  display: inline-flex;
  flex-flow: row nowrap;
  width: calc(100% - ${SIZE * 2}px);
  height: ${SIZE}px;
  margin: 0 8px;
  padding: 0;
  overflow: hidden;
`;

export const Item = styled.li`
  display: inline-flex;
  width: 100%;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  position: relative;
  left: 0;
  transition: left 0.27s linear;
`;
